module.exports = __webpack_public_path__ + "static/media/group.6d75c808.png";